import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/views/index'),
      meta: {
        title: '助力惠宠',
        requireAuth: true
      }
    },
    {
      path: '/login',
      component: () => import('@/views/login'),
      meta: {
        title: '',
        requireAuth: false
      }
    },
    {
      path: '/index',
      component: () => import('@/views/index'),
      meta: {
        title: '助力惠宠',
        requireAuth: true
      }
    },
    {
      path: '/details',
      component: () => import('@/views/Details'),
      meta: {
        title: '详情',
        requireAuth: true
      }
    },
    {
      path: '/forum',
      component: () => import('@/views/Forum'),
      meta: {
        title: '养宠交流',
        requireAuth: true
      }
    },
    {
      path: '/raise',
      component: () => import('@/views/Raise'),
      meta: {
        title: '我要求助',
        requireAuth: true
      }
    },
    {
      path: '/center',
      component: () => import('@/views/Center'),
      meta: {
        title: '个人中心',
        requireAuth: true
      }
    },
    {
      path: '/raise-food-records',
      component: () => import('@/views/RaiseFoodRecords'),
      meta: {
        title: '求助记录',
        requireAuth: true
      }
    },
    {
      path: '/donate-records',
      component: () => import('@/views/DonateRecords'),
      meta: {
        title: '支持记录',
        requireAuth: true
      }
    },
    {
      path: '/base-auth-info',
      component: () => import('@/views/BaseAuthInfo'),
      meta: {
        title: '基地认证信息',
        requireAuth: true
      }
    },
    {
      path: '/base-auth',
      component: () => import('@/views/BaseAuth'),
      meta: {
        title: '基地认证',
        requireAuth: true
      }
    },
    {
      path: '/pay',
      component: () => import('@/views/Pay'),
      meta: {
        title: '支持',
        requireAuth: true
      }
    },
    {
      path: '/system',
      component: () => import('@/views/System'),
      meta: {
        title: '系统维护',
        requireAuth: false
      }
    },
    {
      path: '/order',
      component: () => import('@/views/Order'),
      meta: {
        title: '订单',
        requireAuth: true
      }
    },
    {
      path: '/shuanq',
      component: () => import('@/views/ShuanQ'),
      meta: {
        title: '感谢您的支持',
        requireAuth: false
      }
    }, {
      path: '/loginFailed',
      component: () => import('@/views/LoginFailed'),
      meta: {
        title: '登录失败',
        requireAuth: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js